function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M478.752,131.704l-56-88c-1.469-2.308-4.016-3.705-6.752-3.704H64c-2.736-0.001-5.283,1.396-6.752,3.704l-56,88l0.128,0.08 C0.515,133.025,0.036,134.49,0,136v296c0,4.418,3.582,8,8,8h464c4.418,0,8-3.582,8-8V136c-0.036-1.51-0.515-2.975-1.376-4.216 L478.752,131.704z M457.424,128H294.68L281.6,56h130.008L457.424,128z M200,144h80v40h-80V144z M265.328,56l13.072,72h-76.8 l13.088-72H265.328z M68.392,56H198.4l-13.096,72H22.576L68.392,56z M464,424H16V144h168v48c0,4.418,3.582,8,8,8h96 c4.418,0,8-3.582,8-8v-48h168V424z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M57.6,163.2l-24,32l12.8,9.6L56,192v72h16v-72l9.6,12.8l12.8-9.6l-24-32c-2.908-3.535-8.131-4.042-11.666-1.134 C58.32,162.406,57.94,162.786,57.6,163.2z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M129.6,163.2l-24,32l12.8,9.6L128,192v72h16v-72l9.6,12.8l12.8-9.6l-24-32c-2.908-3.535-8.131-4.042-11.666-1.134 C130.32,162.406,129.94,162.786,129.6,163.2L129.6,163.2z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M332,368h44v20c0,11.046,8.954,20,20,20s20-8.954,20-20v-4h-16v4c0,2.209-1.791,4-4,4s-4-1.791-4-4v-20h44 c6.627,0,12-5.373,12-12v-4c0-35.346-28.654-64-64-64s-64,28.654-64,64v4C320,362.627,325.373,368,332,368z M384,304 c26.499,0.026,47.974,21.501,48,48h-96C336.026,325.501,357.501,304.026,384,304z"
});

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var _ref18 = /*#__PURE__*/React.createElement("g", null);

var _ref19 = /*#__PURE__*/React.createElement("g", null);

var _ref20 = /*#__PURE__*/React.createElement("g", null);

var SvgOscarIconSvg = function SvgOscarIconSvg(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 480 480",
    style: {
      enableBackground: "new 0 0 480 480"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, React.createElement("path", {
    style: {
      fill: "#8C6239"
    },
    d: "M8,136h464v296H8V136z"
  }), React.createElement("path", {
    style: {
      fill: "#A67C52"
    },
    d: "M8,136l56-88h352l56,88H8z"
  }), React.createElement("path", {
    style: {
      fill: "#C69C6D"
    },
    d: "M208,48l-16,88v56h96v-56l-16-88H208z"
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgOscarIconSvg, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/OscarIconSvg.3293ffdd.svg";
export { ForwardRef as ReactComponent };